import type * as React from 'react';
import subjectLeft, { type SubjectLeftAction } from '@Application/Subjects/Actions/subjectLeft';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

/** Empties what the left dossier holds in the stores, so the next visit reads it again. */
export default (subject: SubjectAddress) => {
	return async (dispatch: React.Dispatch<SubjectLeftAction>): Promise<SubjectLeftAction> => {
		const action = subjectLeft(subject);
		dispatch(action);
		return action;
	};
};
